export default __webpack_public_path__ + "static/media/wpdev-all-access-bundle.ba9a00e1.png";